// import { signoutUser } from '@/store/auth/reducer';
import axios from 'axios';
import store from '../store/Store';
import { authlogout } from '../store/Authentication';

export const BASE_URL = "https://api.sophie-care.com"


const instance = axios.create({
    baseURL: BASE_URL,
});

export const clearUserData = () => {
    store.dispatch(authlogout());
};
export const getHeaders = async () => {

    if (store.getState()?.Authlogin?.data?.token) {
        return {
            Authorization: `Bearer ${store.getState()?.Authlogin?.data?.token}`,
        };
    }

    return {};
};

// Add a request interceptor
instance.interceptors.request.use(
    (config) => {
        const conf = config;
        // Determine which token to use based on the request URL
        const url = conf.url || '';
        let token;
        if (window.location.pathname.includes('/onboarding')) {
            token = store.getState()?.Authlogin?.dataTemp?.token;
        } else {
            token = store.getState()?.Authlogin?.data?.token;
        }
        if (token) {
            conf.headers.Authorization = `Bearer ${token}`;
        }
        return conf;
    },
    // Do something before request is sent
    (error) => {
        return Promise.reject(error)
    }
);

// Add a response interceptor
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        // Do something with response error
        if (
            error.response &&
            error.response.status === 401
        ) {
            clearUserData();
        }
        return Promise.reject(error);
    },
);

export default instance;